import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index";

Vue.use(VueRouter);

const Lunbotushezhi = {
  path: "/lunbotushezhi",
  name: "lunbotushezhi",
  component: () => import("@/views/lunbotushezhi"),
};
const Ruzhushenqing = {
  path: "/ruzhushenqing",
  name: "ruzhushenqing",
  component: () => import("@/views/ruzhushenqing"),
};
const Shangxiehuiguanli = {
  path: "/shangxiehuiguanli",
  name: "shangxiehuiguanli",
  component: () => import("@/views/shangxiehuiguanli"),
};
const Tieziguanli = {
  path: "/tieziguanli",
  name: "tieziguanli",
  component: () => import("@/views/tieziguanli"),
};

const Huodongguanli = {
  path: "/huodongguanli",
  name: "huodongguanli",
  component: () => import("@/views/huodongguanli"),
};

const Dangjianguanli = {
  path: "/dangjianguanli",
  name: "dangjianguanli",
  component: () => import("@/views/dangjianguanli"),
};

const Saishiguanli = {
  path: "/saishiguanli",
  name: "saishiguanli",
  component: () => import("@/views/saishiguanli"),
};

const Peixunguanli = {
  path: "/peixunguanli",
  name: "peixunguanli",
  component: () => import("@/views/peixunguanli"),
};

const Zhengcejiedu = {
  path: "/zhengcejiedu",
  name: "zhengcejiedu",
  component: () => import("@/views/zhengcejiedu"),
};

const Huiyuanguanli = {
  path: "/huiyuanguanli",
  name: "huiyuanguanli",
  component: () => import("@/views/huiyuanguanli"),
};
const Huiyuanziliaoshenhe = {
  path: "/huiyuanziliaoshenhe",
  name: "huiyuanziliaoshenhe",
  component: () => import("@/views/huiyuanziliaoshenhe"),
};
const Mingpianguanli = {
  path: "/mingpianguanli",
  name: "mingpianguanli",
  component: () => import("@/views/mingpianguanli"),
};
const Shenfenzhengshenhe = {
  path: "/shenfenzhengshenhe",
  name: "shenfenzhengshenhe",
  component: () => import("@/views/shenfenzhengshenhe"),
};
const Jubaoguanli = {
  path: "/jubaoguanli",
  name: "jubaoguanli",
  component: () => import("@/views/jubaoguanli"),
};
const Yijianfankui = {
  path: "/yijianfankui",
  name: "yijianfankui",
  component: () => import("@/views/yijianfankui"),
};
const Tixiandakuan = {
  path: "/tixiandakuan",
  name: "tixiandakuan",
  component: () => import("@/views/tixiandakuan"),
};
const Xiaofeijilu = {
  path: "/xiaofeijilu",
  name: "xiaofeijilu",
  component: () => import("@/views/xiaofeijilu"),
};
const Duanxinpeizhi = {
  path: "/duanxinpeizhi",
  name: "duanxinpeizhi",
  component: () => import("@/views/duanxinpeizhi"),
};
const Zhanghaoguanli = {
  path: "/zhanghaoguanli",
  name: "zhanghaoguanli",
  component: () => import("@/views/zhanghaoguanli"),
};
const Tiezishenhe = {
  path: "/tiezishenhe",
  name: "tiezishenhe",
  component: () => import("@/views/tiezishenhe"),
};
const Xiaochengxuzhifu = {
  path: "/xiaochengxuzhifu",
  name: "xiaochengxuzhifu",
  component: () => import("@/views/xiaochengxuzhifu"),
};
const Fufeizhidingpeizhi = {
  path: "/fufeizhidingpeizhi",
  name: "fufeizhidingpeizhi",
  component: () => import("@/views/fufeizhidingpeizhi"),
};

const AssociationMember = {
  path: "/associationmember",
  name: "AssociationMember",
  component: () => import("@/views/associationmember"),
};

const Wodexiehuixinxi = {
  path: "/wodexiehuixinxi",
  name: "wodexiehuixinxi",
  component: () => import("@/views/shangxiehuixiangqing"),
};

const AdminLogList = {
  path: "/adminLogList",
  name: "adminLogList",
  component: () => import("@/views/rizhi/adminLogList"),
};

const AdminLoginList = {
  path: "/adminLoginList",
  name: "adminLoginList",
  component: () => import("@/views/rizhi/adminLoginList"),
};

const UserLogList = {
  path: "/userLogList",
  name: "userLogList",
  component: () => import("@/views/rizhi/userLogList"),
};

// const ConfigurationCenter = {
//   path: "/configurationCenter",
//   name: "ConfigurationCenter",
//   component: () => import("@/views/configuration-center"),
// };

const HomeKingKong = {
  path: "/homeKingKong",
  name: "HomeKingKong",
  component: () => import("@/views/configuration-center/home-king-kong/index"),
};

const HomeBanner = {
  path: "/homeBanner",
  name: "HomeBanner",
  component: () => import("@/views/configuration-center/home-banner/index"),
};

const HomeBannerEdit = {
  path: "/homeBannerEdit",
  name: "HomeBannerEdit",
  component: () => import("@/views/configuration-center/home-banner/edit"),
};

const LotteryTicket = {
  path: "/lotteryTicket",
  name: "LotteryTticket",
  component: () => import("@/views/configuration-center/lottery-ticket/index"),
};

const LotteryTicketEdit = {
  path: "/lotteryTicketEdit",
  name: "LotteryTicketEdit",
  component: () => import("@/views/configuration-center/lottery-ticket/edit"),
};

const LotteryTicketBanner = {
  path: "/lotteryBanner",
  name: "LotteryTticket",
  component: () => import("@/views/configuration-center/lottery-ticket-banner/index"),
};

const LotteryTicketBannerEdit = {
  path: "/lotteryBannerEdit",
  name: "LotteryTicketBannerEdit",
  component: () => import("@/views/configuration-center/lottery-ticket-banner/edit"),
};

const HomeKingKongEdit = {
  path: "/homeKingKongEdit",
  name: "HomeKingKongEdit",
  component: () => import("@/views/configuration-center/home-king-kong/edit"),
};

const CountyApproval = {
  path: "/countyApproval",
  name: "CountyApproval",
  component: () => import("@/views/approval/countyApproval/index"),
};

const DataReportByApproval = {
  path: "/dataReportByApproval",
  name: "DataReportByApproval",
  component: () => import("@/views/approval/dataReportByApproval/index"),
};

const SchoolListByApproval = {
  path: "/schoolListByApproval",
  name: "SchoolListByApproval",
  component: () => import("@/views/approval/schoolListByApproval/index"),
};

const CountyApprovalEdit = {
  path: "/CountyApprovalEdit",
  name: "CountyApprovalEdit",
  component: () => import("@/views/approval/countyApproval/edit"),
};

const TicketWelfare = {
  path: "/ticketWelfare",
  name: "TicketWelfare",
  component: () => import("@/views/ticketWelfare/index"),
};

const TicketWelfareEdit = {
  path: "/ticketWelfareEdit",
  name: "TicketWelfareEdit",
  component: () => import("@/views/ticketWelfare/edit"),
};


const WallHonor = {
  path: "/wallHonor",
  name: "wallHonor",
  component: () => import("@/views/wallHonor/index"),
};

const WallHonorEdit = {
  path: "/wallHonorEdit",
  name: "WallHonorEdit",
  component: () => import("@/views/wallHonor/edit"),
};

const WallHonorUsers = {
  path: "/wallHonorUsers",
  name: "WallHonorUsers",
  component: () => import("@/views/wallHonor/users"),
};

const IframePage = {
  path: "/iframePage",
  name: "iframePage",
  component: () => import("@/views/iframePage/index"),
};

const ruleMapping = {
  wallHonor: WallHonor,
  // wallHonorEdit: WallHonorEdit,
  // configurationCenter: ConfigurationCenter,
  ticketWelfare: TicketWelfare,
  // ticketWelfareEdit: TicketWelfareEdit,
  countyApproval: CountyApproval,
  homeKingKong: HomeKingKong,
  homeBanner: HomeBanner,
  lotteryTicket: LotteryTicket,
  tiezishenhe: Tiezishenhe,
  lunbotushezhi: Lunbotushezhi,
  ruzhushenqing: Ruzhushenqing,
  shangxiehuiguanli: Shangxiehuiguanli,
  tieziguanli: Tieziguanli,
  zhengcejiedu: Zhengcejiedu,
  huodongguanli: Huodongguanli,
  dangjianguanli: Dangjianguanli,
  saishiguanli: Saishiguanli,
  peixunguanli: Peixunguanli,
  huiyuanguanli: Huiyuanguanli,
  huiyuanziliaoshenhe: Huiyuanziliaoshenhe,
  mingpianguanli: Mingpianguanli,
  shenfenzhengshenhe: Shenfenzhengshenhe,
  jubaoguanli: Jubaoguanli,
  yijianfankui: Yijianfankui,
  tixiandakuan: Tixiandakuan,
  xiaofeijilu: Xiaofeijilu,
  duanxinpeizhi: Duanxinpeizhi,
  zhanghaoguanli: Zhanghaoguanli,
  fufeizhidingpeizhi: Fufeizhidingpeizhi,
  xiaochengxuzhifu: Xiaochengxuzhifu,
  wodexiehuixinxi: Wodexiehuixinxi,
  associationmember: AssociationMember,
  adminLogList: AdminLogList,
  adminLoginList: AdminLoginList,
  userLogList: UserLogList,
  IframePage: IframePage,
};
const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login"),
  },
  {
    path: "/home",
    name: "home",
    redirect: "/shouye",
    component: () => import("@/views/home"),
    children: [
      {
        path: "/bianjiwodezhanghao",
        name: "bianjiwodezhanghao",
        component: () => import("@/views/bianjiwodezhanghao"),
      },
      {
        path: "/wodezhanghao",
        name: "wodezhanghao",
        component: () => import("@/views/wodezhanghao"),
      },
      {
        path: "/shouye",
        name: "shouye",
        component: () => import("@/views/shouye"),
      },
      {
        path: "/xinzenglunbotu",
        name: "xinzenglunbotu",
        component: () => import("@/views/xinzenglunbotu"),
      },
      {
        path: "/fabutiezi",
        name: "fabutiezi",
        component: () => import("@/views/fabutiezi"),
      },
      {
        path: "/xiugailunbotu",
        name: "xiugailunbotu",
        component: () => import("@/views/xiugailunbotu"),
      },
      {
        path: "/fabuhuodongguanli",
        name: "fabuhuodongguanli",
        component: () => import("@/views/fabuhuodongguanli"),
      },

      {
        path: "/fabudangjianguanli",
        name: "fabudangjianguanli",
        component: () => import("@/views/dangjianguanli/fabu"),
      },
      {
        path: "/xiangqingdangjianguanli",
        name: "xiangqingdangjianguanli",
        component: () => import("@/views/dangjianguanli/xiangqing"),
      },

      {
        path: "/fabusaishiguanli",
        name: "fabusaishiguanli",
        component: () => import("@/views/saishiguanli/fabu"),
      },
      {
        path: "/xiangqingsaishiguanli",
        name: "xiangqingsaishiguanli",
        component: () => import("@/views/saishiguanli/xiangqing"),
      },

      {
        path: "/fabupeixunguanli",
        name: "fabupeixunguanli",
        component: () => import("@/views/peixunguanli/fabu"),
      },
      {
        path: "/xiangqingpeixunguanli",
        name: "xiangqingpeixunguanli",
        component: () => import("@/views/peixunguanli/xiangqing"),
      },

      {
        path: "/zhengcejiedufabu",
        name: "zhengcejiedufabu",
        component: () => import("@/views/zhengcejiedufabu"),
      },
      // 非菜单路由
      {
        path: "/huiyuanxiangqing",
        name: "huiyuanxiangqing",
        component: () => import("@/views/huiyuanxiangqing"),
      },
      {
        path: "/xiaofeixiangqing",
        name: "xiaofeixiangqing",
        component: () => import("@/views/xiaofeixiangqing"),
      },
      {
        path: "/mingpianhuiyuanziliao",
        name: "mingpianhuiyuanziliao",
        component: () => import("@/views/mingpianhuiyuanziliao"),
      },
      {
        path: "/tianjiazhanghao",
        name: "tianjiazhanghao",
        component: () => import("@/views/tianjiazhanghao"),
      },
      {
        path: "/tiezichakanxiangqing",
        name: "tiezichakanxiangqing",
        component: () => import("@/views/tiezichakanxiangqing"),
      },
      {
        path: "/shangxiehuixiangqing",
        name: "shangxiehuixiangqing",
        component: () => import("@/views/shangxiehuixiangqing"),
      },
      {
        path: "/wodexiehuixinxi",
        name: "wodexiehuixinxi",
        component: () => import("@/views/shangxiehuixiangqing"),
      },
      {
        path: "/zhengcejieduxiangqing",
        name: "zhengcejieduxiangqing",
        component: () => import("@/views/zhengcejieduxiangqing"),
      },
      {
        path: "/huiyuanxiangqingchakan",
        name: "huiyuanxiangqingchakan",
        component: () => import("@/views/huiyuanxiangqingchakan"),
      },
      {
        path: "/huodongguanlichakanxiangqing",
        name: "huodongguanlichakanxiangqing",
        component: () => import("@/views/huodongguanlichakanxiangqing"),
      },
      {
        path: "/shenfenzhengxiangqing",
        name: "shenfenzhengxiangqing",
        component: () => import("@/views/shenfenzhengxiangqing"),
      },
      {
        path: "/jubaoxiangqing",
        name: "jubaoxiangqing",
        component: () => import("@/views/jubaoxiangqing"),
      },
      {
        path: "/yijianfankuixiangqing",
        name: "yijianfankuixiangqing",
        component: () => import("@/views/yijianfankuixiangqing"),
      },
      {
        path: "/AddXiehui",
        name: "AddXiehui",
        component: () => import("@/views/AddXiehui"),
      },
      {
        path: "/dangyuanguanli",
        name: "dangyuanguanli",
        component: () => import("@/views/dangyuanguanli"),
      },
      {
        path: "/activity-release",
        name: "Activity-release",
        component: () => import("@/views/activities/release.vue"),
      },
      HomeBannerEdit,
      LotteryTicketEdit,
      LotteryTicketBanner,
      LotteryTicketBannerEdit,
      HomeKingKongEdit,
      CountyApprovalEdit,
      DataReportByApproval,
      SchoolListByApproval,
      TicketWelfareEdit,
      WallHonorEdit,
      WallHonorUsers
    ],
  },
  // {
  //   path: '*',
  //   component: () => import('@/views/NotFound')
  // }
];

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes,
});
// 挂载路由导航守卫,to表示将要访问的路径，from表示从哪里来，next是下一个要做的操作
router.beforeEach((to, from, next) => {
  if (to.path === "/login") {
    next();
  } else {
    const token = sessionStorage.getItem("token");
    if (!token) {
      next("/login");
    } else {
      next();
    }
  }
});
export function initDynamicRoutes() {
  //  根据二级权限对路由进行动态的添加
  console.log("1111", router);
  const currentRoutes = router.options.routes;
  let rightList = [];
  rightList = store.state.rightList;

  // TEMP: 新增动态路由模拟
  // rightList.push({
  //   id: 9999,
  //   name: "彩票发放",
  //   icon: "el-icon-setting",
  //   url: "",
  //   sub_menu: [
  //     {
  //       id: 9991,
  //       icon: "",
  //       name: "彩票活动列表",
  //       url: "ticketWelfare",
  //     },
  //     {
  //       id: 9991,
  //       icon: "",
  //       name: "彩票活动详情",
  //       url: "ticketWelfareEdit",
  //     },
  //   ],
  // });

  // rightList.push({
  //   id: 9999,
  //   name: "彩票发放",
  //   icon: "el-icon-setting",
  //   url: "ticketWelfare",
  // });

  rightList.forEach((item) => {
    if (item.url) {
      const temp = ruleMapping[item.url];
      if (temp) currentRoutes[2].children.push(temp);
      // console.log("temp1", temp);
    } else {
      item.sub_menu.forEach((item) => {
        const temp = ruleMapping[item.url];
        if (temp) currentRoutes[2].children.push(temp);
        // console.log("temp2", temp);
      });
    }
  });

  currentRoutes.push({
    path: "*",
    component: () => import("@/views/NotFound"),
  });
  router.addRoutes(currentRoutes);
}

export default router;
